<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.email" clearable placeholder="邮箱" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.eventCode" clearable placeholder="事件" style="width:160px">
        <el-option v-for="e in events" :key="e.value" :label="e.label" :value="e.value" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="staffName" label="员工" width="140" />
      <el-table-column prop="email" label="邮箱" min-width="180" />
      <el-table-column label="订阅事件" min-width="220"><template slot-scope="{ row }">{{ formatEvents(row.eventCodes) }}</template></el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }"><el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag></template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.recipientId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.recipientId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />
    <el-dialog :title="form.recipientId ? '修改收件人' : '新增收件人'" :visible.sync="visible" width="520px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-form-item label="员工">
          <el-select v-model="form.staffId" filterable clearable style="width:100%" @change="onStaff">
            <el-option v-for="s in staffs" :key="s.staffId" :label="(s.staffNumber || '') + ' / ' + (s.staffName || '')" :value="s.staffId" />
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>
        <el-form-item label="订阅事件">
          <el-checkbox-group v-model="eventChecked">
            <el-checkbox v-for="e in events" :key="e.value" :label="e.value">{{ e.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listEmailRecipient, getEmailRecipient, saveEmailRecipient, updateEmailRecipient, deleteEmailRecipient } from '../../api/email'
import { selectStaff } from '../../api/staff'

const EVENTS = [
  { value: 'MAINTENANCE_DUE', label: '维保计划到期' },
  { value: 'MAINTENANCE_ORDER', label: '维保工单生成' },
  { value: 'TEST', label: '测试邮件' }
]

function emptyForm() {
  return { recipientId: '', staffId: '', email: '', active: '1' }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { email: '', eventCode: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, form: emptyForm(), eventChecked: ['MAINTENANCE_DUE'],
      events: EVENTS, staffs: []
    }
  },
  created() {
    this.load()
    selectStaff().then(res => { this.staffs = res.data || [] }).catch(() => {})
  },
  methods: {
    formatEvents(codes) {
      const map = {}
      this.events.forEach(e => { map[e.value] = e.label })
      return String(codes || '').split(',').map(c => map[c.trim()] || c.trim()).filter(Boolean).join('、')
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listEmailRecipient({ currentPage: this.page, pageSize: this.pageSize, email: this.query.email, eventCode: this.query.eventCode })
        .then(res => {
          const body = res.data || {}
          this.list = body.list || []
          this.total = body.totalCount || 0
        }).finally(() => { this.loading = false })
    },
    onStaff(id) {
      const staff = this.staffs.find(s => s.staffId === id)
      if (staff && staff.email && !this.form.email) this.form.email = staff.email
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.eventChecked = ['MAINTENANCE_DUE']
        this.visible = true
        return
      }
      getEmailRecipient(id).then(res => {
        const d = res.data || {}
        this.form = { recipientId: d.recipientId, staffId: d.staffId || '', email: d.email || '', active: d.active || '1' }
        this.eventChecked = String(d.eventCodes || '').split(',').map(s => s.trim()).filter(Boolean)
        this.visible = true
      })
    },
    submit() {
      if (!this.form.email) { this.$message.warning('邮箱不能为空'); return }
      if (!this.eventChecked.length) { this.$message.warning('请至少选择一个通知事件'); return }
      this.saving = true
      const payload = { ...this.form, staffId: this.form.staffId || null, eventCodes: this.eventChecked.join(',') }
      const req = this.form.recipientId ? updateEmailRecipient(payload) : saveEmailRecipient(payload)
      req.then(() => { this.$message.success('已保存'); this.visible = false; this.load() }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteEmailRecipient([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
